import React from "react";

const TextComponent = ({ text, breakWord }) => {
    const formattedText = text.replace(new RegExp(breakWord, 'g'), "\n");
    return <pre>{formattedText}</pre>;
}

export default TextComponent;
